import React from 'react'
import styled from "styled-components";
import Link from 'gatsby-link'

import { AppearRight, BounceIn } from './animations';

const LinkItem = styled.div`
    text-decoration: none;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    margin: 6px 0;
    color: #fff;
    font-size: 11px;

    .sourceLogo {
      width: 32px;
      height: 32px;
      border-radius: 50%;
      margin-right: 16px;
      margin-left: 12px;
      opacity: 0;
      animation: ${props => props.isActive ? `` : `${BounceIn} .8s`};
      animation-delay: ${props => 0.3 - props.delay / 20}s;
      animation-fill-mode: forwards;
    }

    .link {
      opacity: 0;
      animation: ${props => props.isActive ? `` : `${AppearRight} .8s`};
      animation-delay: ${props => 0.3 - props.delay / 20}s;
      animation-fill-mode: forwards;
    }
`;

const NavLink = ({ handleItem, isActive, delay, href, title, image }) => {

  const link__itemActive = {
    background: '#fff',
    color: '#000',
    padding: '4px 12px',
    borderRadius: '16px',
    boxShadow: '0 4px 24px rgba(0, 0, 0, 0.16)',
    transition: 'all .3s ease'
  }

  const link__item = {
    textDecoration: 'none',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    margin: '8px 0',
    padding: '4px 0',
    color: '#fff',
    fontSize: '16px',
    lineHeight: '20px',
    transition: 'all .3s ease'
  }

  return(
    <LinkItem onClick={handleItem} delay={delay}>
      <span className="link">
        <Link style={link__item} activeStyle={link__itemActive} exact to={href}>
          {title}
        </Link>
      </span>
      <a href={href}><img className="sourceLogo" src={image} /></a>
    </LinkItem>
)};

export default NavLink


// WEBPACK FOOTER //
// ./src/components/MobNav/navLink.js